<template>
    <div class="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
        <div property="schema:name" :content="product.title"></div>
        <ProductTitle class="lg:hidden" :product="product"/>
        <div class="lg:w-112 flex justify-center lg:justify-start mb-5">
            <div rel="schema:image" :resource="product.image.url"></div>
            <ResponsiveImage
                class="object-contain max-h-96 w-full"
                :media-item="product.image"
                :alt="product.title"
            />
            <!--                                <div class="flex flex-wrap -mx-3 -mb-3 justify-between">-->
            <!--                                    <div class="w-1/2 xs:w-1/4 px-3 mb-3">-->
            <!--                                        <a class="relative group block h-24 w-full bg-blueGray-900 rounded-md" href="#">-->
            <!--                                            <div class="absolute top-0 left-0 h-full w-full transform -translate-y-1 -translate-x-1 group-hover:translate-y-0 group-hover:translate-x-0 transition duration-300">-->
            <!--                                                <img class="img-fluid w-full h-full object-cover rounded-md border-2 border-black" src="shopal-assets/product-details/product-detail-small1.png" alt="" data-config-id="auto-img-2-1">-->
            <!--                                            </div>-->
            <!--                                        </a>-->
            <!--                                    </div>-->
            <!--                                    <div class="w-1/2 xs:w-1/4 px-3 mb-3">-->
            <!--                                        <a class="relative group block h-24 w-full bg-blueGray-900 rounded-md" href="#">-->
            <!--                                            <div class="absolute top-0 left-0 h-full w-full transform -translate-y-1 -translate-x-1 group-hover:translate-y-0 group-hover:translate-x-0 transition duration-300">-->
            <!--                                                <img class="img-fluid w-full h-full object-cover rounded-md border-2 border-black" src="shopal-assets/product-details/product-detail-small2.png" alt="" data-config-id="auto-img-3-1">-->
            <!--                                            </div>-->
            <!--                                        </a>-->
            <!--                                    </div>-->
            <!--                                    <div class="w-1/2 xs:w-1/4 px-3 mb-3">-->
            <!--                                        <a class="relative group block h-24 w-full bg-blueGray-900 rounded-md" href="#">-->
            <!--                                            <div class="absolute top-0 left-0 h-full w-full transform -translate-y-1 -translate-x-1 group-hover:translate-y-0 group-hover:translate-x-0 transition duration-300">-->
            <!--                                                <img class="img-fluid w-full h-full object-cover rounded-md border-2 border-black" src="shopal-assets/product-details/product-detail-small3.png" alt="" data-config-id="auto-img-4-1">-->
            <!--                                            </div>-->
            <!--                                        </a>-->
            <!--                                    </div>-->
            <!--                                    <div class="w-1/2 xs:w-1/4 px-3 mb-3">-->
            <!--                                        <a class="relative group block h-24 w-full bg-blueGray-900 rounded-md" href="#">-->
            <!--                                            <div class="absolute top-0 left-0 h-full w-full transform -translate-y-1 -translate-x-1 group-hover:translate-y-0 group-hover:translate-x-0 transition duration-300">-->
            <!--                                                <img class="img-fluid w-full h-full object-cover rounded-md border-2 border-black" src="shopal-assets/product-details/product-detail-small4.png" alt="" data-config-id="auto-img-5-1">-->
            <!--                                            </div>-->
            <!--                                        </a>-->
            <!--                                    </div>-->
            <!--                                </div>-->
        </div>

        <slot/>
    </div>
</template>

<script>
import ProductTitle from "@/Partials/Products/ProductTitle.vue";
import ResponsiveImage from "@/Components/ResponsiveImage.vue";

export default {
    components: {ResponsiveImage, ProductTitle},
    props: {
        product: Object,
    }
}
</script>
